import { Injectable } from '@angular/core';
import { ActiveCartService } from '@cart/data-access';
import { CityService } from '@city/feature';
import { DeliveryDate } from '@delivery/const';
import { select, Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { combineLatest, distinctUntilChanged, filter, map, Observable } from 'rxjs';
import { DeliveryActions } from '../store/actions';
import { StateWithDelivery } from '../store/delivery-state';
import { DeliveryDateSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class DeliveryDateFacade {
  constructor(
    private store: Store<StateWithDelivery>,
    private cityService: CityService,
    private activeCartService: ActiveCartService,
  ) {}

  getDeliveryDate(): Observable<DeliveryDate> {
    return this.store.pipe(select(DeliveryDateSelectors.getDeliveryDateValue));
  }

  getDeliveryDateLoading(): Observable<boolean> {
    return this.store.pipe(select(DeliveryDateSelectors.getDeliveryDateLoading));
  }

  getDeliveryDateError(): Observable<boolean> {
    return this.store.pipe(select(DeliveryDateSelectors.getDeliveryDateError));
  }

  getDeliveryDateSuccess(): Observable<boolean> {
    return this.store.pipe(select(DeliveryDateSelectors.getDeliveryDateSuccess));
  }

  getDeliveryDateState(): Observable<StateUtils.LoaderState<DeliveryDate>> {
    return this.store.pipe(select(DeliveryDateSelectors.getDeliveryDateState));
  }

  getDeliveryDateNotAvailable(): Observable<boolean> {
    return this.getDeliveryDateState().pipe(
      filter((value) => Boolean(!value.loading && (value.error || value.success))),
      map((value) => value.error || !value.value),
    );
  }

  loadDeliveryDate(): void {
    this.store.dispatch(new DeliveryActions.LoadDeliveryDate());
  }

  getContextUpdate(): Observable<void> {
    return combineLatest({
      activeBaseStoreCode: this.cityService.activeBaseStoreCode$,
      activeCartId: this.activeCartService.getActiveCartId(),
      entries: this.activeCartService.getEntries(),
    }).pipe(
      distinctUntilChanged(
        (a, b) =>
          a.activeBaseStoreCode === b.activeBaseStoreCode &&
          a.activeCartId === b.activeCartId &&
          JSON.stringify(a.entries) === JSON.stringify(b.entries),
      ),
      map(() => void 0),
    );
  }
}
